module.exports = __webpack_public_path__ + "img/icon_arrow_orange.9988ee2b.svg";